//String type constant
export const VERTEX = 'Vertex'; //Common Vertex Label
export const OWNER_TYPE = 'Owner Type';//Common Owner type Label
export const SHOPIFY_META_FIELD = 'Shopify Metafield';//Common Meta fields Label
export const FLEX_FIELDS = 'Flex fields';//Common Flex fields Label
export const FLEX_FIELD_ID = 'Flex Field ID';//Common Flex fields Label
export const CODE_FLEXIBLE_FIELDS = 'Code Flexible Fields';//Common Code flexible fields Label
export const NUMERIC_FLEXIBLE_FIELDS = 'Numeric Flexible Fields';//Common Numeric flexible fields Label
export const DATE_FLEXIBLE_FIELDS = 'Date Flexible Fields';//Common Date flexible fields Label
export const NAME_SPACE = 'Name Space';//Common Name Space Label
export const ALREADY_HAVE_ACC = 'Already have an account? Enter your information to connect your account.';
export const CONNECT_UR_VERTEX_ACC = 'Connect your Vertex® Account';//Common already have Label
export const COMPANY_CODE = 'Company Code';//Common Company Code Label
export const CLIENT_ID = 'Client ID';//Common Client ID Label
export const CLIENT_PASS_KEY = 'Client Secret';//Common Client Secret Label
export const IDENTITY_PROVIDER = 'Identity Provider';//Common Client Secret Label
export const O_SERIES_URL_LABEL = 'O Series URL';
export const CALCULATION_API_URL = 'Calculation API URL';//Common Calculation API URL Label
export const DONT_HAVE_ACC = `Don’t have a Vertex® account?`;//Common Don't have acc Label
export const SIGN_UP = 'Sign Up';//Common Sign Up Label
export const POWERED_BY_VERTEX = `Powered by Vertex® Cloud Indirect Tax`;
export const ACC_STATUS = 'Account Status';//Common Account Status Label
export const CONNECT_VERTEX_ACC = 'Connect Vertex Account';//Common Connect Vertex Account Label
export const VERTEX_INC_URL = `https://www.vertexinc.com/`;//Common Vertex URL Label
export const IS_REQUIRED = 'is required.';//Common is req. Label
export const SIGN_UP_HERE = `https://www.vertexinc.com/campaign/shopify`;
export const TAX_APPLICATION = 'TAX APPLICATION';//Common Tax application Label
export const TYPE_DATE = 'date';
export const TYPE_NUMERIC = 'numeric';
export const TYPE_CODE = 'code';
export const TYPE_RESERVED = 'reserved';
export const WELCOME_MF_FF = `You will now be directed to the Metafield and Flexfield configuration screen,
 where you will be able to:`;
export const FF_TYPE_KEY = 'flexFieldType';
export const FF_ID_KEY = 'flexFieldId';
export const MF_NAME = 'metaFieldName';
export const NAME_SPACE_KEY = 'nameSpace';
export const OWNER_TYPE_KEY = 'ownerType';
export const MF_OWNERTYPE_PRODUCT = 'PRODUCT';
export const MF_OWNERTYPE_VARIANT = 'PRODUCTVARIANT';
export const MAX_TWENTY_UNIQUE_MF = `The maximum limit of unique metafields has been exceeded.
 Reduce the number of mapped metafields to 20 or fewer.`;
export const DUPLICATE_FF_IN = `Duplicate flex field Id:`;
export const FOUND_IN = 'found in';
export const SELECT_FF_FOR_MF = `please select the FF corresponding to the MF :`;
export const CONFIRM_SUBMIT = 'Are you sure you want to submit this data?';
export const SUCCESS_TITLE = `Success!`;
export const ERROR_TITLE = 'Error';
export const UN_MAP = '<unmap>';
export const SELECT_OPTION_LABEL = '<select>';
export const SHOPIFY_URL_PREFIX = `https://admin.shopify.com/store/`;
export const SHOPIFY_URL_SUFFIX = `/settings/taxes`;
export const CONFIRMATION_PAGE_TEXT_1 = 'You are not currently connected to Vertex. ';
export const CLICK_LABEL = 'Click';
export const CONFIRMATION_PAGE_TEXT_3 = `below to log into Vertex account and configure the tax settings
 you would like to use for your Shopify store.`;
export const CONFIRMATION_PAGE_TEXT_4 = `You can only use one tax service on Shopify at a time.
  If you connect to your Vertex account,
  any existing connection to another tax service will be disabled.`;
export const COMPANY_CODE_TOOLTIP = `Configured in your taxpayer setup.`;
export const CLIENT_ID_TOOLTIP = `Created with OAuth Credentials, see the Integration Guide for details.`;
export const CLIENT_SECRET_TOOLTIP = `Generated with Client ID for OAuth Credentials, see Integration Guide for details.`;
export const IDENTITY_PROVIDER_TOOLTIP = `Your IDP provider helps verify identity information.`;
export const CALCULATION_API_URL_TOOLTIP = `Only used by Vertex On Demand and On-Premise customers. This is the URL of your O Series environment.`; 
export const URL_SEPARATOR = '-;-';
export const SHOP_ID = 'shopId';
export const SHOP_URL = 'shopUrl';
export const HMAC = 'hmacData';
export const HOST = 'hostData';
export const BASE64 = 'base64';
export const UTF8 = 'utf8';
export const ZERO_STR = '0';
export const CANCEL_LABEL = 'Cancel';
export const CONNECT_ACC_LABEL = 'Connect Account';
export const NO_ACC_PAGE_TEXT_1 = 'Find the best tax solution for growing your business globally.';
export const NO_ACC_PAGE_TEXT_2_PART_1 = `Vertex for Shopify automates important parts of the order process, to help you reduce`;
export const NO_ACC_PAGE_TEXT_2_PART_2 = `errors, accelerate transactions, and get paid faster. This all adds up to a better`;
export const NO_ACC_PAGE_TEXT_2_PART_3 = `experience for you and your customers.`;
export const NO_ACC_PAGE_TEXT_3 = 'Connect with us today to learn more';
export const BACK_LABEL = 'Back';
export const BLANK_TARGET = '_blank';
export const HEADER_TEXT_1 = `For more help and support, visit `;
export const HEADER_LINK_LABEL = `Vertex Community`;
export const TAX_CONFIG = `Tax Configuration 11`;
export const CONNECTION_TAX_SETTINGS = 'Connection and Tax Settings';
export const FIELD_MAPPING = 'Field Mapping';
export const VERTEX_CONN_SETTINGS = 'Vertex Connection Settings';
export const TAX_SETTINGS = 'Tax Settings';
export const SHIPPING_PRODUCT_CLASS = 'Shipping Product Class';
export const GIFT_CARD_PRODUCT_CODE = 'Gift Card Product Code';
export const EDIT_TAX_SETTINGS = 'Edit Tax Settings';
export const TEXT = 'text';
export const SAVE = 'Save';
export const VERTEX_COMMUNITY_LINK = `https://community.vertexinc.com/s/`;
export const OFF = 'off';
export const GC_PRODUCT_CODE_KEY = 'gc_product_code';
export const SHIPPING_CODE_KEY = 'shipping_code';
export const ALPHA_NUMERIC_ERROR = 'Only alphanumeric characters allowed.';
export const DEFAULT_GC_PRODUCT_CODE_VALUE = 'SHOPIFYGC';
export const DEFAULT_SHIPPING_CODE_VALUE = 'SHIPPING';
export const SUCCESS_BANNER = 'success';
export const TAX_SETTINGS_SUCCESS_MESSAGE = `You’ve successfully updated your Tax Settings.`;
export const UN_MAP_LABEL = 'Unmap';
export const META_FIELD_NAME = 'Metafield Name';
export const META_FIELD_TYPE = 'Metafield Type';
export const META_FIELD_NAMESPACE = 'Metafield Namespace';
export const FLEXIBLE_FIELD_ID = 'Flexible Field ID';
export const FLEXIBLE_FIELD_ID_KEY = 'flexibleFieldId';
export const PRODUCT_CLASS_LABEL = 'Product Class';
export const OT_PRODUCT = 'product';
export const SCOPE_WARNING_INFO_PART_1 = `Some features of the Vertex Tax app require additional access to Shopify data. `;
export const SCOPE_UPDATE_LINK = `Click here`;
export const SCOPE_WARNING_INFO_PART_2 = ` to review and update your Vertex Tax app access.`;
export const WARNING_LABEL = `Warning`;
export const SELECT_LABEL = 'Select';
export const ERROR_LOG = 'Error Log';
export const DOWNLOAD_DETAILS = 'Download details';
export const TYPE = 'Type';
export const TOTAL = 'Total';
export const EMPTY_ERROR_LOG_TITLE = 'No orders found';
export const EMPTY_ERROR_LOG_DESCRIPTION = 'You do not have any orders with errors at this time.';
export const API_ERROR_MESSAGE = 'We seem to have hit a snag. Please try again later.';
export const SUMMARY_LABEL = `Summary`;
export const INFO_BANNER = 'info';
export const INVOICE_REFUND_FAILED_XLS = `Invoicerefundfailed_logs.xlsx`;
export const ID = 'id';
export const DOWNLOAD = 'download';
export const DOWNLOAD_ERR_ATTR = 'downloadingErrorLogFile';
export const TRUE_STR = 'true';
export const FALSE_STR = 'false';
export const SUBMIT_LABEL = 'Submit';
export const HTTPS = `https://`;
export const ENABLE_LABEL = 'Enable';
export const DISABLE_LABEL = 'Disable';
export const SALES_ENABLE_ID = 'salesEnable';
export const SALES_DISABLE_ID = 'salesDisable';
export const TAX_CALC_URL_KEY = 'tax_calc_url';
export const ORDER_SYNC_ENABLED_KEY = 'order_sync_enabled';
export const SALES_CHANNEL_ENABLED_KEY = 'sales_channel_enabled';
export const JOURNAL_ORDERS = 'Journal Orders';
export const SALES_CHANNEL = 'Sales Channel';
export const ENABLED_LABEL = 'Enabled';
export const DISABLED_LABEL = 'Disabled';
export const ORDER_SYNC_ENABLED_HELP_TEXT = `Determines whether orders are invoiced and added to the Vertex tax journal. 
Make sure you have no orders in the queue when you disable this setting.`;
export const SALES_CHANNEL_ENABLED_HELP_TEXT = `Determines whether to add sales channel orders to the Vertex tax journal. 
Enabling this option will allow sales channel orders to be added to the Vertex tax journal while existing orders remain unchanged.`;
export const VERTEX_IDP = 'Vertex IDP';
export const LEGACY_IDP = 'Legacy IDP';
export const LBL_RECOMMENDED = `(Recommended)`;
export const LEGACY_IDP_HELP_TXT = `Support for this option will end in the second quarter of 2025.`;
export const SELECTED_IDP_KEY = 'selectedIdp';
export const UPDATE_IDP_BANNER_TITLE = `Update for Identity Provider`;
export const UPDATE_IDP_BANNER_INFO = `Support for the Legacy IDP option will end in the second quarter of 2025. 
If you do not change your identify provider before support ends, all transactions will fail. 
Update in `;
export const LEGACY_IDP_KEY = 'is_Legacy_idp';
export const VERX_REL_KEY = 'idpMigrationFlag';
export const UPDATE_IDP_PROVIDER = `Update Identity Provider`;
export const UPDATE_UR_IDP = 'Update your Identity Provider';
export const UPDATE_UR_IDP_HELP_TEXT = `When you update your Identity Provider you will also have to update your Client`;
export const UPDATE_UR_IDP_HELP_TEXT_1 = `ID and Client Secret.`;
export const LBL_UPDATE = 'Update';
//Number type constant
export const GO_BACK = -1;
export const ZERO = 0;
export const ONE = 1;
export const TWO = 2;
export const THREE = 3;
export const FOUR = 4;
export const TEN = 10;
export const TWENTY = 20;
export const FORTY = 40;
export const TWO_HUNDRED = 200;
export const THIRTY = 30;
//Boolean
export const TRUE = true;
export const FALSE = false;
//Placeholders
export const PH_COMPANY_CODE = `e.g. CORP`;
export const PH_CT_ID = `e.g. 4c96a50dd28643a7967e3351e0c67b56`;
export const PH_CT_SECRET = `e.g. 5adbd82d5e0248ee12048ae6102e94ba`;
export const PH_O_SERIES_URL = `e.g. https://yourcompany.ondemand.vertexinc.com`;
/*
Route constants
*/
export const ONBOARDING_ROUTE = 'onboarding';//onboarding Route
export const ERROR_ROUTE = 'error';//error Route
export const TAX_CONFIGURATION_ROUTE = 'tax-configuration';//tax configuration Route
export const NO_ACCOUNT_ROUTE = 'no-account';
export const SHOPIFY_UI_ROUTE = `/ui`;//Polaris Route
export const SHOPIFY_UI_NO_ACCOUNT_ROUTE = `/ui/no-account`;//Polaris No Account Route
export const SHOPIFY_UI_ERROR_ROUTE = `/ui/error`;//Polaris Error Route
/* 
Header constants
*/
export const CONTENT_TYPE_OBJ = {
  'Content-Type': 'application/json'
};
// Regex
export const ALPHA_NUMERIC = /[^a-zA-Z0-9 ]/g;
